export default class ReadingTime {
  initialize() {
    console.debug('== Reading Time ==')

    const readingContainer = document.querySelector('.reading-time')

    if (readingContainer) {
      const target = document.querySelector(readingContainer.dataset.target)

      const readingTime = this.computeReadingTime(target)
      readingContainer.textContent = readingTime + ' minutes'
    }
  }

  computeReadingTime(target) {
    const wordsPerMinute = 200
    let totalWords = 0
    const paragraphs = target.querySelectorAll('p')

    paragraphs.forEach((paragraph) => {
      totalWords += paragraph.textContent.split(' ').length
    })

    return Math.ceil(totalWords / wordsPerMinute)
  }

  static init() {
    const readingTimeInstance = new ReadingTime()
    readingTimeInstance.initialize()
  }
}
